import {Component, OnDestroy, OnInit} from '@angular/core';
import {CustomerService} from '../../../../services/customer.service';
import {OrderService} from '../../../../services/order.service';
import {OrderModel} from '../../../../models/order.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DAY_HOURS, STATUSES} from '../../../../global';

@Component({
  selector: 'app-orders-history',
  templateUrl: './orders-history.component.html',
  styleUrls: ['./orders-history.component.scss']
})
export class OrdersHistoryComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  showLoader: boolean = true;
  dayHours: any = DAY_HOURS;
  orders: Array<OrderModel> = [];
  upcomingOrders: Array<OrderModel> = [];
  orderStatuses: Array<string> = STATUSES;

  constructor(private customerService: CustomerService,
              private orderService: OrderService) {
  }

  ngOnInit() {
    this.customerService.getCurrentCustomer()
      .then(customer => {
        this.orderService.getCustomersOrders(customer.uid)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(orders => {
            this.showLoader = false;
            this.orders = orders;
            this.upcomingOrders = [];
            orders.forEach(order => {
              if (order.status < 5) this.upcomingOrders.push(order);
            });
          });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
